<template>
  <div>
    <h2 class="-sr-only">{{ $t('js.shared_garden.legend.title') }}</h2>

    <rui-list-item :image="multiPatternSrc" :caption="$t('js.shared_garden.legend.multiple')" static />
    <rui-list-item :image="emptyPatternSrc" :caption="$t('js.shared_garden.legend.empty')" static />
    <rui-list-item v-for="resource in resources"
                   :key="resource.id"
                   :image="resource.picturePath"
                   :caption="resource.name"
                   :sub-caption="resource.latinName"
                   static />
  </div>
</template>

<script>
import RuiListItem from '@experiments-labs/rise_ui/src/components/ListItem/ListItem.vue'

import emptyPatternSrc from '../../../assets/images/empty_pattern.svg'
import multiPatternSrc from '../../../assets/images/multi_pattern.svg'

export default {
  name: 'GardenLegend',
  components: { RuiListItem },
  data () {
    return {
      multiPatternSrc,
      emptyPatternSrc,
    }
  },
  computed: {
    resources () {
      return this.$store.getters.resources
    },
  },
}
</script>
